import { Query } from "@tanstack/react-query";

import isArray from "../IsArray";

// format error message for all Tanstack query errors
export const formatErrorMessage = (error: any, query: Query) => {
	let messages: string[] = ["Something went wrong. Please try again later."];
	// webserver error
	if (isArray(error?.data?.errors) && error?.data?.errors.length > 0) {
		messages = error.data.errors;
		// webserver error
	} else if (error?.data?.error) {
		messages = [error.data.error];
		//webserver error where we return errors but its only a string, not an array
	} else if (typeof error?.data?.errors === "string" && error?.data?.errors.length > 0) {
		messages = [error?.data?.errors];
		//internal api error
	} else if (error?.data?.message) {
		messages = [error.data.message];
		//generic error
	} else if (error?.message) {
		messages = [error.message];
	} else if (query?.meta?.errorMessage) {
		if (typeof query.meta.errorMessage === "object") {
			messages = [JSON.stringify(query.meta.errorMessage)];
		} else {
			messages = [query.meta.errorMessage.toString()];
		}
	}

	// add this block to handle non-JSON errors
	if (error instanceof SyntaxError) {
		messages = ["Unknown error encountered. Please contact our support team for further information."];
	}

	return messages;
};
